import { storyblokEditable } from 'gatsby-source-storyblok';
import React from 'react';
import StoryBlokLink from '../StoryblokLink';
import Container from '../Container';

const button = ({ blok }) => {
  const { button_text: buttonText, button_link: buttonLink } = blok;

  return (
    <div {...storyblokEditable(blok)}>
      <Container>
        <StoryBlokLink
          to={buttonLink.story?.full_slug.replace('home', '') || buttonLink.cached_url.replace('home', '')}
          className="button-primary text-left text-lg md:text-xl mt-4 hyphens-auto"
        >
          {buttonText}
        </StoryBlokLink>

      </Container>

    </div>
  );
};

export default button;
